import entryMixin from '../../assets/mixins/entry';
import langs from '../../assets/locale/lang/red-envelope';

export default {
  mixins: [entryMixin],
  langs,
  langName: 'redEnvelope',
};
